import React, { Children } from 'react';
import { Printer } from 'lucide-react';
import { Button } from '../components/ui/Button';
type PriceItem = {
  name: string;
  price: string;
};
type Category = {
  title: string;
  items: PriceItem[];
};
const categories: Category[] = [{
  title: 'Consultations',
  items: [{
    name: 'New Patient Exam (incl. 2 X-Rays)',
    price: '£60'
  }, {
    name: 'Routine Check Up',
    price: '£50'
  }, {
    name: 'Emergency Appointment',
    price: '£75'
  }, {
    name: 'Orthodontics Consultation',
    price: '£60'
  }]
}, {
  title: 'Dental Hygiene',
  items: [{
    name: 'Scale & Polish',
    price: '£95'
  }, {
    name: 'Airflow Stain Removal',
    price: '£45'
  }, {
    name: 'Scale & Polish + Airflow + Whitening',
    price: '£350'
  }, {
    name: 'Deep Cleaning (per quadrant)',
    price: '£190'
  }, {
    name: 'Curettage (1–3 teeth)',
    price: '£60–80'
  }]
}, {
  title: 'Fillings & Restorations',
  items: [{
    name: 'Composite Filling (small)',
    price: '£120–150'
  }, {
    name: 'Composite Filling (medium)',
    price: '£150–180'
  }, {
    name: 'Composite Filling (large)',
    price: '£180–250'
  }, {
    name: 'Composite Bonding',
    price: '£250'
  }, {
    name: 'Tooth Restoration / Build up',
    price: '£200'
  }, {
    name: 'Fiber Post',
    price: '£150'
  }, {
    name: 'Temporary Filling',
    price: '£50'
  }, {
    name: 'Re-cement Crown (each)',
    price: '£80–119'
  }]
}, {
  title: "Children's Dental Treatment",
  items: [{
    name: 'Routine Dental Examination',
    price: '£60'
  }, {
    name: 'Dental Hygiene / Cleaning (child)',
    price: '£65'
  }, {
    name: 'Fluoride Application',
    price: '£25'
  }, {
    name: 'Fissure Sealant (per tooth)',
    price: '£50'
  }, {
    name: 'White Filling (baby tooth)',
    price: '£80–120'
  }, {
    name: 'Metal Crown (Stainless Steel Crown)',
    price: '£180'
  }, {
    name: 'Simple Extraction (baby / primary tooth)',
    price: '£50–120'
  }, {
    name: 'Pulpotomy',
    price: '£180–200'
  }, {
    name: 'Root Canal Treatment (baby tooth)',
    price: '£200–250'
  }]
}, {
  title: 'Root Canal Treatment',
  items: [{
    name: 'Incisor',
    price: '£400'
  }, {
    name: 'Premolar',
    price: '£500'
  }, {
    name: 'Molar',
    price: '£600'
  }, {
    name: 'Re-Root (Incisor)',
    price: '£600'
  }, {
    name: 'Re-Root (Premolar)',
    price: '£750'
  }, {
    name: 'Re-Root (Molar)',
    price: '£850'
  }]
}, {
  title: 'Whitening & Cosmetic',
  items: [{
    name: 'Clinical Teeth Whitening',
    price: '£280'
  }, {
    name: 'Home Whitening Kit',
    price: '£275'
  }, {
    name: 'Intracanal Bleaching (1 tooth)',
    price: '£150'
  }]
}, {
  title: 'Tooth Extraction & Oral Surgery',
  items: [{
    name: 'Simple Extraction',
    price: 'from £120'
  }, {
    name: 'Surgical Extraction',
    price: 'from £180–250'
  }, {
    name: 'Wisdom Tooth Removal',
    price: 'from £180–350'
  }, {
    name: 'Apicectomy',
    price: '£600'
  }, {
    name: 'Bone Grafting',
    price: 'from £350'
  }, {
    name: 'Frenectomy',
    price: '£250–350'
  }]
}, {
  title: 'Dentures',
  items: [{
    name: 'Full Acrylic Denture (one arch)',
    price: '£900'
  }, {
    name: 'Partial Acrylic Denture',
    price: '£600'
  }, {
    name: 'Chrome Cobalt Dentures',
    price: '£1100'
  }, {
    name: 'Denture Repair',
    price: 'from £250'
  }]
}, {
  title: 'Crowns, Veneers & Bridges',
  items: [{
    name: 'Metal-Ceramic Crown',
    price: '£550'
  }, {
    name: 'Zirconia Crown',
    price: '£600–750'
  }, {
    name: 'E.max Veneer',
    price: '£600–750'
  }, {
    name: 'Composite Veneer',
    price: '£350'
  }, {
    name: 'Porcelain Bridge (per unit)',
    price: '£600'
  }]
}, {
  title: 'Orthodontics',
  items: [{
    name: 'Braces',
    price: 'from £1800'
  }, {
    name: 'Retainers (removable)',
    price: '£200'
  }, {
    name: 'Night Guard',
    price: '£200'
  }, {
    name: 'Fixed Retainer (per arch)',
    price: '£200'
  }, {
    name: 'Clear Aligner',
    price: 'from £3800'
  }]
}, {
  title: 'Radiography',
  items: [{
    name: 'Small X-ray',
    price: '£20'
  }, {
    name: 'OPG',
    price: '£50'
  }, {
    name: 'Cephalometric',
    price: '£50'
  }, {
    name: 'CBCT (single jaw)',
    price: '£100'
  }, {
    name: 'CBCT (both jaws)',
    price: '£150'
  }, {
    name: 'CBCT (segment)',
    price: '£80'
  }]
}, {
  title: 'Indirect Restorations',
  items: [{
    name: 'Ceramic Inlay',
    price: '£400'
  }, {
    name: 'Ceramic Onlay',
    price: '£450'
  }, {
    name: 'Ceramic Overlay',
    price: '£500'
  }]
}, {
  title: 'Dental Implants',
  items: [{
    name: 'Implant with Crown',
    price: 'from £1500'
  }, {
    name: 'Sinus Lift',
    price: 'from £800'
  }]
}, {
  title: 'Injectables & Aesthetic',
  items: [{
    name: 'Botox',
    price: 'from £250'
  }, {
    name: 'Hydrafacial',
    price: '£250'
  }]
}];
function CategoryBlock({
  category
}: {
  category: Category;
}) {
  return <div className="mb-2.5 break-inside-avoid" data-id="element-2142">
      <div className="bg-teal-700 text-white text-[8.5px] font-bold uppercase tracking-wider px-2 py-1 mb-1" data-id="element-2143">
        {category.title}
      </div>
      <div className="space-y-[3px] px-0.5" data-id="element-2144">
        {category.items.map((item, idx) => <div key={idx} className="flex items-baseline gap-0.5" data-id="element-2145">
            <span className="text-[9px] text-gray-700 leading-tight flex-shrink-0" style={{
          maxWidth: '72%'
        }} data-id="element-2146">
              {item.name}
            </span>
            <span className="flex-grow border-b border-dotted border-teal-200 mx-0.5 relative top-[-1px]" data-id="element-2147" />
            <span className="text-[9px] font-bold text-teal-800 whitespace-nowrap tabular-nums flex-shrink-0" data-id="element-2148">
              {item.price}
            </span>
          </div>)}
      </div>
    </div>;
}
export function PrintPricePage() {
  const handlePrint = () => window.print();
  const today = new Date().toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  return <div className="min-h-screen bg-gray-100 p-6 print:p-0 print:bg-white" data-id="element-2149">
      {/* Controls */}
      <div className="no-print max-w-[210mm] mx-auto mb-6 flex items-center justify-between" data-id="element-2150">
        <div data-id="element-2151">
          <h1 className="text-xl font-bold text-gray-900" data-id="element-2152">
            Dentico Clinic — Price List
          </h1>
          <p className="text-sm text-gray-500 mt-0.5" data-id="element-2153">
            Tip: Enable <strong data-id="element-2154">Background graphics</strong> in print settings
            for best results.
          </p>
        </div>
        <Button onClick={handlePrint} className="gap-2 shadow-md" data-id="element-2155">
          <Printer className="w-4 h-4" data-id="element-2156" />
          Print Price List
        </Button>
      </div>

      {/* A4 Page — fixed height to match exactly one A4 */}
      <div className="price-page bg-white mx-auto shadow-xl print:shadow-none flex flex-col" style={{
      width: '210mm',
      height: '297mm'
    }} data-id="element-2157">
        {/* Compact Header */}
        <div className="border-b-2 border-teal-700 px-8 pt-5 pb-3 flex-shrink-0" data-id="element-2158">
          <div className="flex items-center justify-between" data-id="element-2159">
            <div className="flex items-center gap-3" data-id="element-2160">
              <img src="https://cdn.magicpatterns.com/uploads/oHJPxkkc7f6GgU5uyo3LQX/ChatGPT_Image_Feb_5,_2026,_03_12_40_PM.png" alt="Dentico Clinic" className="h-10 w-auto object-contain" data-id="element-2161" />
              <div className="border-l border-gray-300 pl-3" data-id="element-2162">
                <div className="text-lg font-bold text-gray-900 tracking-tight leading-none" data-id="element-2163">
                  Dentico<span className="text-teal-600" data-id="element-2164">Clinic</span>
                </div>
                <div className="text-[9px] text-gray-500 uppercase tracking-widest mt-0.5" data-id="element-2165">
                  Private Dentistry · London, Angel · 360–364 City Road, EC1V
                  2PY
                </div>
              </div>
            </div>
            <div className="text-right" data-id="element-2166">
              <div className="text-xl font-bold text-teal-900 uppercase tracking-wide leading-none" data-id="element-2167">
                Price List
              </div>
              <div className="text-[9px] text-gray-400 mt-1" data-id="element-2168">
                {today} · denticoclinic.co.uk
              </div>
            </div>
          </div>
        </div>

        {/* Two-column price grid — fills remaining space */}
        <div className="flex-grow px-8 pt-4 pb-2 grid grid-cols-2 gap-x-6 items-start overflow-hidden" data-id="element-2169">
          <div data-id="element-2170">
            {categories.slice(0, Math.ceil(categories.length / 2)).map((cat, idx) => <CategoryBlock key={idx} category={cat} data-id="element-2171" />)}
          </div>
          <div data-id="element-2172">
            {categories.slice(Math.ceil(categories.length / 2)).map((cat, idx) => <CategoryBlock key={idx} category={cat} data-id="element-2173" />)}
          </div>
        </div>

        {/* Compact Footer */}
        <div className="flex-shrink-0 mx-8 pt-2 pb-4 border-t border-gray-200" data-id="element-2174">
          <p className="text-[8px] text-gray-400 text-center leading-relaxed" data-id="element-2175">
            Prices are indicative and may vary. A consultation is required
            before treatment. &nbsp;·&nbsp; +44 7345 197820 (WhatsApp)
            &nbsp;·&nbsp; denticoclinic.co.uk &nbsp;·&nbsp; Book:
            denticoclinic.patientportal.onl/bookings
          </p>
        </div>
      </div>

      <style data-id="element-2176">{`
        @media print {
          @page {
            size: A4 portrait;
            margin: 0;
          }
          html, body {
            margin: 0;
            padding: 0;
            background: white;
          }
          .no-print {
            display: none !important;
          }
          .price-page {
            width: 210mm !important;
            height: 297mm !important;
            box-shadow: none !important;
            margin: 0 !important;
            overflow: hidden !important;
          }
        }
      `}</style>
    </div>;
}